/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.wrapper {
  display: inline-block;
  position: relative;
}
.showTooltip {
  visibility: visible !important;
}
.tooltip {
  position: absolute;
  top: calc(var(--spacing, 0.25rem) * -7);
  --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
  translate: var(--tw-translate-x) var(--tw-translate-y);
  padding-inline: calc(var(--spacing, 0.25rem) * 3);
  padding-block: var(--spacing, 0.25rem);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-sm, 0.25rem);
  z-index: 1002;
  background-color: var(--color-gray-600, #525252);
  color: var(--color-white, #fff);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
  visibility: hidden;
  white-space: nowrap;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-font-weight: initial;
    }
  }
}
